<template>
  <v-dialog
    content-class="dialogText"
    v-model="isDialog"
    light
    persistent
    max-width="700"
  >
    <v-card v-if="isDialog">
      <div class="absX" @click.passive="closeDialog">
        <v-icon x-large class="myGray">mdi-window-close</v-icon>
      </div>
      <div class="pa-5 thisDialog text-center">
        <h3 class="mb-5">Wähle ein Bestellmodus:</h3>

        <div class="d-flex align-center justify-center">
          <div class="mobile pa-3">
            <OrderModeSwitcher
              @selected="closeDialog"
              >
            </OrderModeSwitcher>
          </div>
          <div class="tablet pl-2 pr-2 pt-4 pb-7">
            <OrderModeSwitcher
              @selected="closeDialog"
              >
            </OrderModeSwitcher>
          </div>
        </div>

        <!--        <div class="mt-7">-->
        <!--          <div class="d-flex justify-center">-->
        <!--            &lt;!&ndash;            <v-btn @click="closeDialog" rounded depressed color="primary">&ndash;&gt;-->
        <!--            &lt;!&ndash;              Cancel&ndash;&gt;-->
        <!--            &lt;!&ndash;            </v-btn>&ndash;&gt;-->
        <!--            <template v-if="userCode?.length>3">-->
        <!--              &lt;!&ndash;              <div class="pl-2"></div>&ndash;&gt;-->
        <!--              <v-btn @click="ok" rounded depressed color="primary">-->
        <!--                Save-->
        <!--              </v-btn>-->
        <!--            </template>-->
        <!--          </div>-->
        <!--        </div>-->

      </div>
    </v-card>


  </v-dialog>
</template>


<script>
import store from "@/store/store";
import OrderModeSwitcher from "./OrderModeSwitcher.vue";
import {ebus} from "../vendor/ebus";

export default {
  props: {
    dialog: Boolean,
  },
  components: {
    OrderModeSwitcher,
  },
  data() {
    return {
      isDialog: false,

    }
  },
  computed: {
    availableOrderModes() {
      let modes = [];
      if (store.getters.isKiosk) {
        if (store.getters.enableKioskInhouseOhnePay || store.getters.enableKioskInhouseMitPay) {
          modes.push('inhouse');
        }
        if (store.getters.enableKioskTakeAwayOhnePay || store.getters.enableKioskTakeAwayMitPay) {
          modes.push('takeAway');
        }
      } else {
        if (store.getters.enableInhouseOhnePay || store.getters.enableInhousePay) {
          if ((!!store.getters.selectedOrderModeByUser && store.getters.selectedOrderModeByUser !== 'takeAway' && store.getters.selectedOrderModeByUser !== 'delivery') || !store.state.hideInhouseForTakeaway) {
            modes.push('inhouse');
          }
        }
        if (store.getters.enableTakeawayOhnePay || store.getters.enableTakeawayPay) {
          if (store.getters.selectedOrderModeByUser !== 'inhouse' || !store.state.hideTakeawayForInhouse) {
            modes.push('takeAway');
          }
        }
        if (!store.getters.isKiosk && (store.getters.enableDeliveryOhnePay || store.getters.enableDeliveryPay)) {
          if (store.getters.selectedOrderModeByUser !== 'inhouse' || !store.state.hideTakeawayForInhouse) {
            modes.push('delivery');
          }
        }
      }

      return modes;
    },
  },
  watch: {
    dialog(newValue) {
      this.isDialog = newValue;
      if (newValue) {
        //init
        this.reset();
      }
    },
    isDialog(newValue) {
      if (!newValue) {
        // this.ready = false;
        // if (store.getters.selectedOrderModeByUser) {
        //   ebus.$emit('lazyAddRemeberedItems');
        // }
        this.$emit('close');
      }
    }
  },
  activated() {
    this.reset();
  },
  methods: {
    ok() {
      this.goAhead();
    },
    reset() {

    },
    closeDialog() {
      this.isDialog = false;
      // this.$emit('close');//no
    },
    goAhead() {
      this.closeDialog();
    },
    handleDismiss() {
      this.closeDialog();
    }
  },
}
</script>

<style lang="scss" scoped>

.thisDialog {
  min-height: 180px;
  padding-top: 30px !important;
}


</style>
